import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { NewReportQuery, NewReportQueryVariables } from '@/modules/common/types';

import { GET_NEW_REPORT } from '../api/newReport.query';
import { useRecommendationGenerationUpdates } from './use-recommendation-generation-updates';

export const useNewReport = ({
  id,
  projectId,
}: {
  id?: string | null;
  projectId?: string | null;
}) => {
  useRecommendationGenerationUpdates();

  const shouldSkip = !id || !projectId;
  const { data, loading } = useQuery<NewReportQuery, NewReportQueryVariables>(GET_NEW_REPORT, {
    variables: {
      id: id ?? '',
      projectId: projectId ?? '',
    },
    skip: shouldSkip,
  });

  const sortedChapters = useMemo(
    () =>
      data?.newReport.newReportChapter
        ?.map((chapter) => ({
          ...chapter,
          dataPoints: [...(chapter.dataPoints ?? [])].sort(
            (a, b) => (a.position ?? 0) - (b.position ?? 0)
          ),
        }))
        .sort((a, b) => (a.position ?? 0) - (b.position ?? 0)),
    [data?.newReport.newReportChapter]
  );

  const normalizedData = useMemo(
    () =>
      data
        ? {
            ...data,
            newReport: { ...data.newReport, newReportChapter: sortedChapters },
          }
        : null,
    [data, sortedChapters]
  );

  return {
    data: normalizedData,
    loading,
  };
};
